import { IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { styles } from './FoldersListSearchInput.styles';

const intl = {
  label: 'Search Folders',
  clearSearch: 'Clear search'
};

type FoldersListSearchInputProps = {
  value: string;
  dataTest?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
};

export function FoldersListSearchInput({
  value,
  dataTest = 'foldersListSearch',
  disabled = false,
  onChange
}: FoldersListSearchInputProps) {
  return (
    <TextField
      variant="outlined"
      placeholder={intl.label}
      data-test={dataTest}
      disabled={disabled}
      fullWidth
      InputProps={{
        'aria-label': intl.label,
        sx: value ? styles.inputWithClearIcon : styles.input,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={styles.searchIcon} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end" sx={styles.closeIconContainer}>
            <IconButton
              aria-label={intl.clearSearch}
              onClick={() => {
                onChange('');
              }}
            >
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ) : null
      }}
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
    />
  );
}
